import en from 'commonAssets/i18n/en';
import merge from 'lodash.merge';

const overrides = {
    "claim_edit_instructions": "Please update any rollover form fields and then click Submit on the bottom of this page to update your Rollover Form.",
    "claim_edit_notice": "Filed a rollover form? <a href=\"javascript:void(0);\" id=\"editClaimBtn\">Click here</a> to edit your rollover form.",
    "claim_edit_title": "Edit Rollover Form",
    "claim_form_errors": "There are errors on the Rollover Form.",
    "claim_submit_error": "There was an error submitting your rollover form, please try again.",
    "claim_submit_success": "Thank you, your rollover form has been submitted.",
    "confirmation_page": {
        "title": 'Your Rollover Form has been submitted successfully.',
        "claim_details": {
            "title": 'Your Rollover Form Details',
            "body": 'ROLLOVER FORM INFORMATION',
            "footer": '<p class="text-center fs-6">If you have any questions regarding your Rollover Form, please provide the Submitted Correlation ID listed above when contacting the Settlement Administrator.</p>',
        },
    },
    "confirmation_this_is_a_copy": "THIS IS A COPY OF YOUR ROLLOVER FORM",
    "confirmation_screen_additional": {
        "body": "<p class=\"fw-bold\">You will receive a confirmation and copy of your roll over form via email.</p><p>You may also print this screen for your records.</p><p>If you don't receive a confirmation email after 3 days, please check your spam filter.</p>",
    },
    "contact_us_select_dropdown": {
        "claim_form": "Rollover Form",
    },
    "deadline_claim": "The deadline to submit a roll over form has passed.",
    "nav_submit_claim_button": "Submit Rollover Form",
    "not_eligible_submit_claim": "You are not eligible to submit a roll over form.",
    "otp_instructions_2": "Please enter the 6 digit code below to access your roll over form.",
};

export default { en: merge(en, overrides) };
